import React, { useState, useEffect } from "react";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useGlobalContext } from "../Config";
import FormBusquedaCliente from "../components/FormBusquedaCliente";
import FormBusquedaProductos from "../components/FormBusquedaProductos";
import CotizacionesTable from "../components/CotizacionesTable";
import ClientesTable from "../components/ClientesTable";
import UseScrollOnStateChange from "../components/UseScrollOnStateChange";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader.js";
import moment from "moment";

const Cotizacion = (props) => {
  const [additionalSelection, setAdditionalSelection] = useState(false);
  const [alias, setAlias] = useState("");
  const [cotizaciones, setCotizaciones] = useState(null);
  const [carro, setCarro] = useState([]);
  const [cliente, setCliente] = useState("");
  const [clienteLocal, setClienteLocal] = useState(false);
  const [clientes, setClientes] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [criterioBusqueda, setCriterioBusqueda] = useState(false);
  const [desde, setDesde] = useState(null);
  const [displayConfirmation, setDisplayConfirmation] = useState(false);
  const [dni, setDni] = useState("");
  const [empresa, setEmpresa] = useState("TODAS");
  const [empresaArrendadora, setEmpresaArrendadora] = useState(null);
  const [filters2, setFilters2] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [flattenedDataArriendo, setFlattenedDataArriendo] = useState([]);
  const [hasta, setHasta] = useState(null);
  const [isBuscarVisible, setIsBuscarVisible] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isSearchFormVisible, setIsSearchFormVisible] = useState(false);
  const [isTarifaVisible, setIsTarifaVisible] = useState(false);
  const [iva, setIva] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [nombreFantasia, setNombreFantasia] = useState("");
  const [nombreRepresentante, setNombreRepresentante] = useState("");
  const [productosDisponibles, setProductosDisponibles] = useState([
    {
      id: 1,
      name: "Bodega G11 ",
      empresa: "LA SIEMBRA",
      metraje: "120",
      subproducto: null,
      servicio: null,
      cobro: "Factura Afecta",
      desde: desde,
      hasta: hasta,
      oficina: false,
      baño: true,
      modulo: true,
      remAgua: true,
      remEn: true,
      internet: false,
    },
    {
      id: 2,
      name: "Bodega G23 ",
      empresa: "ALTAMIRA",
      metraje: "400",
      subproducto: null,
      servicio: null,
      cobro: "Factura Afecta",
      desde: desde,
      hasta: hasta,
      oficina: true,
      baño: true,
      modulo: true,
      remAgua: false,
      remEn: false,
      internet: true,
    },
  ]);
  const [razonSocial, setRazonSocial] = useState("");
  const [rut, setRut] = useState("");

  const [selectedServicios, setSelectedServicios] = useState([]);
  const [selectedSubproductos, setSelectedSubproductos] = useState([]);

  const [servicioObraCivil, setServicioObraCivil] = useState([]);

  const [showSeleccion, setShowSeleccion] = useState(true);

  const [subtotal, setSubtotal] = useState(0);
  const [subtotalArriendo, setSubtotalArriendo] = useState(0);
  const [subtotalObraCivil, setSubtotalObraCivil] = useState(0);
  const [subtotalServicios, setSubtotalServicios] = useState(0);
  const [tipoProducto, setTipoProducto] = useState("");
  const [total, setTotal] = useState(0);
  const totalSinIva = (
    parseFloat(subtotalArriendo) +
    parseFloat(subtotalObraCivil) +
    parseFloat(subtotalServicios)
  ).toFixed(2);

  const totalConIva = (
    parseFloat(totalSinIva) +
    parseFloat(totalSinIva) * 0.19
  ).toFixed(2);

  // VARIABLES CON STATE //

  // VARIABLES ESTATICAS //
  const estados = ["A", "E"];
  const navigate = useNavigate();
  const location = useLocation();

  const empresas = [
    { name: "TODAS", value: "TODAS" },
    { name: "ALTAMIRA", value: "Altamira" },
    { name: "LA SIEMBRA", value: "LA SIEMBRA" },
  ];

  const [tiposProducto, setTiposProducto] = useState([
    { id: 1, descripcion: "Bodega", code: "Bodega", cobro: "Factura Exenta" },
    { id: 2, descripcion: "Sitio", code: "Sitio", cobro: "Factura Exenta" },
    { id: 3, descripcion: "Casino", code: "Casino", cobro: "Factura Exenta" },
    {
      id: 4,
      descripcion: "Zona Lavado",
      code: "Zona Lavado",
      cobro: "Factura Exenta",
    },
  ]);
  const newItemServicio = {
    id: 4,
    nombre: "Obra Civil",
    cobro: "Nota de Cobro",
    desde: desde ? desde : null,
    hasta: hasta ? hasta : null,
    incluido: true,
    moneda: "UF",
    contrato: true,
    unidad: "Sin unidad",
    tarifa_base: 0,
  };

  function calculateTarifaMensualWithFechas(item) {
    if (
      item.nombre !== "Gasto Común" &&
      item.nombre !== "Electricidad" &&
      item.nombre !== "Agua"
    ) {
      if (item.desde && item.hasta) {
        const totalDays = Math.ceil(
          (item.hasta.getTime() - item.desde.getTime()) / (1000 * 3600 * 24)
        );
        if (item.tarifa_base > 0) {
          const totalTarifaMensual = parseFloat(
            (item.tarifa_base * totalDays).toFixed(2)
          );
          item.tarifa_diaria = parseFloat((totalTarifaMensual / 30).toFixed(2));

          item.tarifa_mensual = totalTarifaMensual;
        } else {
          item.tarifa_mensual = 0;
          item.tarifa_diaria = 0;
        }
      } else {
        item.tarifa_mensual = 0;
        item.tarifa_diaria = 0;
      }
    }
  }

  function calculateTarifaMensualWithMetraje(item) {
    if (
      item.nombre !== "Gasto Común" &&
      item.nombre !== "Electricidad" &&
      item.nombre !== "Agua"
    ) {
      if (item.desde && item.hasta) {
        if (item.tarifa_base > 0) {
          const totalTarifaMensual = parseFloat(
            (item.tarifa_base * item.metraje).toFixed(2)
          );
          item.tarifa_diaria = parseFloat((totalTarifaMensual / 30).toFixed(2));

          item.tarifa_mensual = totalTarifaMensual;
        } else {
          item.tarifa_mensual = 0;
          item.tarifa_diaria = 0;
        }
      } else {
        item.tarifa_mensual = 0;
        item.tarifa_diaria = 0;
      }
    }
  }


  const gastoComunItem = {
    id: 4,
    nombre: "Gasto Común",
    cobro: "Nota de Cobro",
    desde: desde ? desde : null,
    hasta: hasta ? hasta : null,
    tarifa_mensual: "Tarifa Variable",
    incluido: true,
    moneda: "UF",
    contrato: true,
    unidad: "Sin unidad",
    tarifa_base: 0,
    tarifa_diaria: 0,
    color: true,
  };

  const subproductos = [
    {
      id: 1,
      name: "Oficina",
      desde: desde ? desde : null,
      hasta: hasta ? hasta : null,
      cobro: "Factura Exenta",
      moneda: "UF",
      contrato: true,
      unidad: "m²",
      metraje: "20",
      incluido: true,
    },
    {
      id: 2,
      name: "Modulo",
      desde: desde ? desde : null,
      hasta: hasta ? hasta : null,
      cobro: "Factura Exenta",
      moneda: "UF",
      contrato: true,
      unidad: "m²",
      metraje: "20",
      incluido: true,
    },
    {
      id: 3,
      name: "Baño",
      desde: desde ? desde : null,
      hasta: hasta ? hasta : null,
      cobro: "Factura Exenta",
      moneda: "UF",
      contrato: true,
      unidad: "m²",
      metraje: "20",
      incluido: true,
    },
  ];
  const servicios = [
    {
      id: 1,
      nombre: "Internet",
      cobro: "Factura Afecta",
      desde: desde,
      hasta: hasta,
      incluido: false,
      moneda: "UF",
      contrato: true,
      unidad: "Kb/s",
      tarifa_base: 0.012,
      tarifa_diaria: 0,
      color: false,
      tarifa_mensual: 0.36,
    },

    {
      id: 2,
      nombre: "Electricidad",
      cobro: "Factura Exenta",
      desde: desde,
      hasta: hasta,
      incluido: false,
      moneda: "UF",
      contrato: true,
      unidad: "V",
      tarifa_base: 0,
      tarifa_diaria: 0,
      tarifa_mensual: "Tarifa Variable",
      color: true,
    },
    {
      id: 3,
      nombre: "Agua",
      cobro: "Nota de Cobro",
      desde: desde,
      hasta: hasta,
      incluido: false,
      moneda: "UF",
      contrato: true,
      unidad: "L",
      tarifa_base: 0,
      tarifa_diaria: 0,
      tarifa_mensual: "Tarifa Variable",
      color: true,
    },
  ];

  const overviewChartData1 = {
    labels: [
      "Diciembre",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
    ],
    datasets: [
      {
        data: [50, 64, 32, 24, 18, 27, 20, 36, 30],
        borderColor: ["#4DD0E1"],
        backgroundColor: ["rgba(77, 208, 225, 0.8)"],
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };
  const overviewChartData2 = {
    labels: [
      "Diciembre",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
    ],
    datasets: [
      {
        data: [11, 30, 52, 35, 39, 20, 14, 18, 60],
        borderColor: ["#4DD0E1"],
        backgroundColor: ["rgba(77, 208, 225, 0.8)"],
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const overviewChartData3 = {
    labels: [
      "Diciembre",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
    ],
    datasets: [
      {
        data: [20, 29, 39, 36, 45, 24, 28, 20, 15],
        borderColor: ["#4DD0E1"],
        backgroundColor: ["rgba(77, 208, 225, 0.8)"],
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const overviewChartData4 = {
    labels: [
      "Diciembre",
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
    ],
    datasets: [
      {
        data: [30, 39, 50, 21, 33, 18, 10, 24, 20],
        borderColor: ["#4DD0E1"],
        backgroundColor: ["rgba(77, 208, 225, 0.8)"],
        borderWidth: 2,
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const { baseUrl } = useGlobalContext();
  const op = useRef(null);
  const toast = useRef();

  useEffect(() => {
    const currentCarroItem = carro[currentIndex];

    if (!currentCarroItem) {
      return;
    }

    const selectedSubproductosArray = [];
    const selectedServiciosArray = [];
    const selectedObraCivilArray = [];

    const gastoComunIncluded = selectedServiciosArray.find(
      (item) => item.name === "Gasto Común"
    );
    if (!gastoComunIncluded) {
      selectedServiciosArray.push(gastoComunItem);
    }
    if (currentCarroItem.oficina) {
      const selectedSubproducto = { ...subproductos[0], incluido: true };
      selectedSubproductosArray.push(selectedSubproducto);
    }
    if (currentCarroItem.modulo) {
      const selectedSubproducto = { ...subproductos[1], incluido: true };
      selectedSubproductosArray.push(selectedSubproducto);
    }
    if (currentCarroItem.bano) {
      const selectedSubproducto = { ...subproductos[2], incluido: true };
      selectedSubproductosArray.push(selectedSubproducto);
    }
    if (currentCarroItem.internet) {
      selectedServiciosArray.push(servicios[0]);
    }
    if (currentCarroItem.electricidad) {
      selectedServiciosArray.push(servicios[1]);
    }
    if (currentCarroItem.agua) {
      selectedServiciosArray.push(servicios[2]);
    }

    setSelectedServicios(selectedServiciosArray);
    setSelectedSubproductos(selectedSubproductosArray);
    setServicioObraCivil(selectedObraCivilArray);
  }, [carro, currentIndex, subproductos, servicios, gastoComunItem]);
  
  const usuarioId = sessionStorage.getItem("usuario_id");

  const buildCotizacionesUrl = (usuarioId) => {
    return `${baseUrl}getCotizacionesByEstados?idUsuario=${usuarioId}&estados=${[
      "1",
      "2",
    ]}`;
  };
  const getCotizaciones = async () => {
    try {
      setLoading(true);
      setLoading2(true);

      const url = buildCotizacionesUrl(usuarioId);
      const data = await fetchData(url);
      if (Array.isArray(data.cotizaciones)) {
        setCotizaciones(data.cotizaciones);
      } else {
        console.error("Data.cotizaciones no es array:", data.cotizaciones);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setLoading2(false);
    }
  };
  useEffect(() => {
    getCotizaciones();
    setOverviewColors();
    initFilters2();
    calculateTarifaMensualWithFechas(newItemServicio);
    servicios.forEach(calculateTarifaMensualWithFechas);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const calculateSubtotal = (data) => {
    let subtotal = 0;

    for (let i = 0; i < data.length; i++) {
      const rowData = data[i];

      if (
        rowData &&
        rowData.tarifa_mensual !== undefined &&
        rowData.tarifa_mensual !== "Tarifa Variable"
      ) {
        const currentNombre = rowData.nombre;
        const currentTarifaMensual = parseFloat(rowData.tarifa_mensual);

        const nextRow = data[i + 1];
        const nextNombre = nextRow ? nextRow.nombre : null;

        if (currentNombre === nextNombre) {
          continue;
        }

        subtotal += isNaN(currentTarifaMensual) ? 0 : currentTarifaMensual;
      }
    }

    return subtotal.toFixed(2);
  };

  useEffect(() => {
    const subtotalArriendo = calculateSubtotal(flattenedDataArriendo);
    setSubtotalArriendo(subtotalArriendo);
  }, [flattenedDataArriendo]);

  useEffect(() => {
    const subtotalServicios = calculateSubtotal(selectedServicios);
    setSubtotalServicios(subtotalServicios);
  }, [selectedServicios]);

  useEffect(() => {
    const subtotalObraCivil = calculateSubtotal(servicioObraCivil);
    setSubtotalObraCivil(subtotalObraCivil);
  }, [servicioObraCivil]);

  useEffect(() => {
    const calculatedSubtotal =
      parseFloat(subtotalArriendo) +
      parseFloat(subtotalServicios) +
      parseFloat(subtotalObraCivil);

    const calculatedIva = calculatedSubtotal * 0.19;

    const calculatedTotal = calculatedSubtotal + calculatedIva;

    setSubtotal(calculatedSubtotal.toFixed(2));
    setIva(calculatedIva.toFixed(2));
    setTotal(calculatedTotal.toFixed(2));
  }, [subtotalArriendo, subtotalServicios, subtotalObraCivil]);
  // VARIABLES DINAMICAS //

  // VARIABLES ASYNC //

  const fetchData = async (url) => {
    // Create a new Headers object and append the Content-Type
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json;charset=UTF-8");

    // Create the request options, adding the headers
    const requestOptions = {
      method: "GET",
      headers: myHeaders, // Use the myHeaders object with Content-Type
      redirect: "follow",
    };

    // Perform the fetch request with the updated requestOptions
    const response = await fetch(url, requestOptions);

    // Return the response as JSON
    return response.json();
  };
  const searchProductos = async () => {
    try {
      if (!isValidFiltrosProductos()) {
        return;
      }

      resetCarro();

      const empresasArray = mapEmpresas(empresa);
      const tiposArray = mapTipos(tipoProducto);
      const { desdeFiltro, hastaFiltro } = mapDateFilters(desde, hasta);

      setLoading(true);

      const url = buildProductosUrl(
        empresasArray,
        desdeFiltro,
        hastaFiltro,
        tiposArray
      );
      const data = await fetchData(url);

      handleProductosResponse(data);
    } catch (error) {
      console.error(error);
    }
  };

  UseScrollOnStateChange(clientes, "clientesDataTable");
  UseScrollOnStateChange(isSearchFormVisible, "clienteSeleccionado");
  UseScrollOnStateChange(showSeleccion, "cuadroPago");
  UseScrollOnStateChange(!showSeleccion, "subproductosDataTable");

  const handleProductosResponse = (data) => {
    if (Array.isArray(data.productos)) {
      setProductosDisponibles(data.productos);

      setLoading(false);
    } else {
      console.error("Data.clientes no es array:", data.clientes);
    }
  };


  const isValidFiltrosProductos = () => {
    if (!checkCabeceraFiltrosProductos()) {
      return false;
    }
    return true;
  };

  const resetCarro = () => {
    setCarro([]);
  };

  const mapEmpresas = (selectedEmpresa) => {
    const empresaMapping = {
      TODAS: ["2", "3"],
      ALTAMIRA: ["2"],
      "LA SIEMBRA": ["3"],
    };
    return empresaMapping[selectedEmpresa.toUpperCase()] || [];
  };

  const mapTipos = (tipoProductoArray) => {
    return tipoProductoArray.map((tipo) => tipo.descripcion);
  };

  const mapDateFilters = (desde, hasta) => {
    const dateObjectDesde = new Date(desde);
    const dateObjectHasta = new Date(hasta);
    const desdeFiltro = dateObjectDesde.toISOString().split("T")[0];
    const hastaFiltro = dateObjectHasta.toISOString().split("T")[0];

    return { desdeFiltro, hastaFiltro };
  };

  const buildProductosUrl = (
    empresasArray,
    desdeFiltro,
    hastaFiltro,
    tiposArray
  ) => {
    return `${baseUrl}getProductosByFiltro?empresas=${empresasArray}&fechaInicio=${desdeFiltro}&fechaTermino=${hastaFiltro}&tipos=${tiposArray}`;
  };

  const toggleFormVisibility = () => {
    setIsFormVisible(true);
  };

  const handleFormClose = () => {
    setIsFormVisible(false);
    navigate("/cotizacion");
  };

  const buildCrearCotizacionUrl = () => {
    let usuarioId = sessionStorage.getItem("usuario_id");
    return `${baseUrl}crearCotizacion?id_cliente=${cliente.id}&id_creador=${usuarioId}&empresa_arrendadora=${empresaArrendadora}&comentario=`;
  };
  const crearCotizacion = async () => {
    try {
      setLoading(true);
      const crearCotizacionUrl = buildCrearCotizacionUrl();

      const data = await fetchData(crearCotizacionUrl);
      if (!data.respuesta) {
        alert(data.mensaje);
      } else {
        const newUrl = `/selectProductos?idCotizacion=${data.idCotizacion}&idCliente=${cliente.id}&selected=true&activeIndex=1`;
        navigate(newUrl);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        alert(error.response.data.message);
      } else {
        alert("Hubo un error al crear la cotización");
      }
    }
  };
  const buildDetalleCotizacionUrl = (idCotizacion) => {
    return `${baseUrl}getDetalleCotizacionByIdCotizacion?idCotizacion=${idCotizacion}`;
  };
  const handleRowClick = async (rowData) => {
    const idCotizacion = rowData.id;

    // Function to format date, ensuring the output is always in 'yyyy-mm-dd'
    const formatDate = (date, inputFormat) => {
      const parsedDate = moment(date, inputFormat);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
    };

    // Format the 'desde' and 'hasta' properties using the formatDate function
    const formattedDesde = formatDate(rowData.desde, "DD/MM/YYYY");
    const formattedHasta = formatDate(rowData.hasta, "DD/MM/YYYY");
    console.log(rowData);
    if (rowData.estado === "INGRESADA") {
      let newUrl = `/selectProductos?idCotizacion=${idCotizacion}&idCliente=${rowData.cliente.id}&selected=true&activeIndex=1`;
      navigate(newUrl);
    } else {
      try {
        setLoading(true);
        const detalleCotizacionUrl = buildDetalleCotizacionUrl(idCotizacion);

        const data = await fetchData(detalleCotizacionUrl);

        if (data.mensaje === "OK") {
          const encodedParams = data.detalles
            .map((item) => {
              // Omit 'desde' and 'hasta' properties      
              const { ...rest } = item;
              // Convert the object to a URL parameter string
              return encodeURIComponent(JSON.stringify(rest));
            })
            .join(",");

          let newUrl = `/revisarCotizacion?idCliente=${rowData.cliente.id}&idCotizacion=${idCotizacion}&desde=${formattedDesde}&hasta=${formattedHasta}`;
          navigate(newUrl);
        } else {
          alert(data.mensaje);
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message);
        } else {
          alert("Hubo un error al crear la cotización");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const toggleSearchFormVisibility = () => {
    if (!empresaArrendadora) {
      alert("No ha seleccionado ninguna empresa arrendadora");
      return;
    }
    setDisplayConfirmation(false);
    crearCotizacion();
  };

  const getOverviewColors = () => {
    const isLight = props.colorMode === "light";
    return {
      pinkBorderColor: isLight ? "#E91E63" : "#EC407A",
      pinkBgColor: isLight ? "#F48FB1" : "#F8BBD0",
      tealBorderColor: isLight ? "#009688" : "#26A69A",
      tealBgColor: isLight ? "#80CBC4" : "#B2DFDB",
    };
  };
  const setOverviewColors = () => {
    const { pinkBorderColor, pinkBgColor, tealBorderColor, tealBgColor } =
      getOverviewColors();

    overviewChartData1.datasets[0].borderColor[0] = tealBorderColor;
    overviewChartData1.datasets[0].backgroundColor[0] = tealBgColor;

    overviewChartData2.datasets[0].borderColor[0] = tealBorderColor;
    overviewChartData2.datasets[0].backgroundColor[0] = tealBgColor;

    overviewChartData3.datasets[0].borderColor[0] = pinkBorderColor;
    overviewChartData3.datasets[0].backgroundColor[0] = pinkBgColor;

    overviewChartData4.datasets[0].borderColor[0] = tealBorderColor;
    overviewChartData4.datasets[0].backgroundColor[0] = tealBgColor;
  };

  const initFilters2 = () => {
    setFilters2({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      cliente: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      empresa: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      servicio: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      ubicacion: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      desde: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      hasta: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      monto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      estado: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    });
  };

  const checkCabeceraFiltrosProductos = () => {
    const basicChecks =
      empresa !== null &&
      empresa !== undefined &&
      empresa !== "" &&
      tipoProducto !== null &&
      tipoProducto !== undefined &&
      tipoProducto !== "" &&
      desde !== null &&
      desde !== undefined &&
      hasta !== null &&
      hasta !== undefined &&
      hasta !== "";

    const dateChecks = new Date(hasta) >= new Date(desde);

    const currentDate = new Date();
    const currentDateChecks =
      new Date(desde) >= currentDate && new Date(hasta) >= currentDate;

    const isDateValid = dateChecks && currentDateChecks;
    const isBasicValid = basicChecks;
    const isValid = isDateValid && isBasicValid;

    if (!isBasicValid) {
      alert("Debe ingresar todos los parámetros de búsqueda");
    }
    if (!isDateValid && isBasicValid) {
      alert(
        "Las fechas deben ser mayores a la de hoy y la fecha de término debe ser mayor o igual a la de inicio"
      );
    }

    return isValid;
  };

  const hanldeCriterioBusqueda = (e) => {
    setCriterioBusqueda(e.value);
    setNombreRepresentante("");
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
          <Button
            icon="pi pi-pencil"
            label="Editar"
            className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
            onClick={() => handleRowClick(rowData)}
            outlined
          />
      </div>
    );
  };

  const handleSelectCliente = (rowData) => {
    setCliente(rowData);
    setDisplayConfirmation(true);
  };

  const toggle = (event) => {
    op.current.toggle(event);
  };

  const confirmationDialogFooter = (
    <>
      <Button
        type="button"
        label="Cerrar"
        icon="pi pi-times "
        onClick={() => setDisplayConfirmation(false)}
        className="p-button p-button-rounded p-button-outlined"
      />
      <Button
        type="button"
        label="Confirmar"
        icon="pi pi-check"
        onClick={toggleSearchFormVisibility}
        className="p-button p-button-rounded p-button-success"
        autoFocus
        raised
      />
    </>
  );


  useEffect(() => {
    if (location.state?.toggleFormVisibility) {
      toggleFormVisibility();
      if (location.state?.rutCliente) {
        setRut(location.state.rutCliente);
      }
    }
  }, [location.state]);

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Borradores</h4>
          <h6 style={{ marginTop: "5px" }}>¿Cómo vamos?</h6>
          {isFormVisible && (
            <div className="card">
              <Button 
                label=" Volver" 
                icon="pi pi-arrow-left" 
                rounded 
                outlined 
                onClick={handleFormClose}
              />  
              {!isBuscarVisible && (
                <FormBusquedaCliente
                  criterioBusqueda={criterioBusqueda}
                  hanldeCriterioBusqueda={hanldeCriterioBusqueda}
                  clienteLocal={clienteLocal}
                  rut={rut}
                  setRut={setRut}
                  razonSocial={razonSocial}
                  setRazonSocial={setRazonSocial}
                  alias={alias}
                  setAlias={setAlias}
                  nombreFantasia={nombreFantasia}
                  setNombreFantasia={setNombreFantasia}
                  dni={dni}
                  setDni={setDni}
                  isValid={isValid}
                  setIsValid={setIsValid}
                  nombreRepresentante={nombreRepresentante}
                  setNombreRepresentante={setNombreRepresentante}
                  onClientesFound={(clientesEncontrados) => {
                    setClientes(clientesEncontrados);
                    setFiltersApplied(true);
                  }}
                />
              )}

              {filtersApplied && (
                <>
                  {loading ? (
                    <>
                      <Loader />
                    </>
                  ) : (
                    <ClientesTable
                      clientes={clientes}
                      setClientes={setClientes}
                      loading={loading}
                      handleSelectCliente={handleSelectCliente}
                      id="clientesDataTable"
                      isMantenedor={false}
                    />
                  )}
                </>
              )}

              <div className="col-12 md:col-12">
                <Dialog
                  visible={displayConfirmation}
                  onHide={() => setDisplayConfirmation(false)}
                  style={{ width: "450px" }}
                  modal
                  header="Selección de Empresa"
                  footer={confirmationDialogFooter}
                  closeOnEscape
                  dismissableMask
                >
                  <div
                    style={{
                      color: "#333",
                      marginBottom: "20px",
                      textAlign: "center",
                      fontSize: "1.1em"
                    }}
                  >
                    Por favor, seleccione una Empresa Arrendadora para continuar
                  </div>
                  <div className="flex align-items-center justify-content-center">
                    <Dropdown
                      id="empresaArrendadora"
                      value={empresaArrendadora}
                      onChange={async (e) => {
                        setEmpresaArrendadora(e.value);
                      }}
                      options={empresas.filter(
                        (empresa) => empresa.value !== "TODAS"
                      )}
                      optionLabel="name"
                      placeholder="Seleccione Empresa"
                      className="w-full"
                      emptyFilterMessage="No se encontraron empresas"
                      emptyMessage="No hay empresas disponibles"
                    />
                  </div>
                </Dialog>
              </div>
              
              {isSearchFormVisible && !additionalSelection && (
                <>
                  <FormBusquedaProductos
                    baseUrl={baseUrl}
                    cliente={cliente}
                    empresa={empresa}
                    setEmpresa={setEmpresa}
                    empresas={empresas}
                    tipoProducto={tipoProducto}
                    setTipoProducto={setTipoProducto}
                    tiposProducto={tiposProducto}
                    setTiposProducto={setTiposProducto}
                    desde={desde}
                    setDesde={setDesde}
                    hasta={hasta}
                    setHasta={setHasta}
                    isTarifaVisible={isTarifaVisible}
                    searchProductos={searchProductos}
                  />
                  <div className="p-fluid formgrid grid" id="clienteSeleccionado" ></div>
                </>
              )}
            </div>
          )}
          <Toast ref={toast} />
        </div>
      </div>

      <div className="col-12">
          <OverlayPanel ref={op} appendTo={document.body} showCloseIcon style={{width: '60%'}}>
            <img src="\assets\demo\images\mapa.png" alt="nature1" style={{width: '100%'}}/>
          </OverlayPanel>{" "}
          {isFormVisible ? (
            <></>
          ) : (
            <>
              <div className="card">
                <Button
                  label="Nueva Cotización"
                  icon="pi pi-plus"
                  className="mr-2 mb-2 p-button-rounded p-button"
                  onClick={toggleFormVisibility}
                  raised
                />
                <Button
                  label="Ver Mapa"
                  icon="pi pi-map"
                  className="mr-2 mb-2 p-button-rounded p-button-secondary"
                  type="button"
                  onClick={toggle}
                  raised
                />
                <CotizacionesTable
                  cotizaciones={cotizaciones}
                  loading={loading || loading2}
                  actionBodyTemplate={actionBodyTemplate}
                  handleRowClick={handleRowClick}
                />
              </div>
            </>
          )}
        </div>
    </div>
  );
};

export default Cotizacion;
